import { Urls } from '../../Shared/Api';

export default class PhotoService {
    static getPhotoItems() {
        return fetch(Urls.homeImage.getGalleryPhotos)
            .then(res => {
                return res.json();
            });
    }
}


// WEBPACK FOOTER //
// ./Src/Components/PhotoGallery/PhotoService.js